import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initAnalytics } from "./lib/analytics";
import App from "./App";
import "./styles/app.css";

// Analytics: PostHog (eu.posthog.com) — see src/lib/analytics.ts
initAnalytics();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
